import React from 'react';
import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import { pushSelectContentEvent } from 'utils/analytics/pushSelectContentEvent';
import { FadeInImage } from '../../../../../../components/FadeInImage';
import { useVerifyIsMobile } from '../../../../../../hooks/useVerifyIsMobile';
import { getRegion } from '../../../../../../utils/Region';
import useRenderChapas from '../../../../../../hooks/useRenderChapas';
import {PUSHTOHISTORY} from 'constants.js'
//-------------------------------------------------------------------------------
import './style.scss';
import { useNavigate } from 'react-router-dom';
import { getContentListV1 } from 'utils/homologacion/homologacion';
import { IMG_SIZE } from 'utils/homologacion/contants';

export const VerticalCard = ({ contentInfo, isChannels, carouselTitle, contentPosition }) => {
  const { isMobile } = useVerifyIsMobile(768);
  const { renderLabel } = useRenderChapas();
  const { navigateToChannel, nodesSelected } = useMenuRedirect();
  const navigate = useNavigate();

  const handleCardClick = e => {
    e.stopPropagation();

    pushSelectContentEvent(contentInfo, nodesSelected, carouselTitle, contentPosition);

    // Verificar si no es live para mandar al canal
    if (getContentListV1?.IsLive(contentInfo)) {
      // navegar al canal
      navigateToChannel(contentInfo, PUSHTOHISTORY);
      return;
    }

    // Redireccionamiento;
    navigate(
      `/${getRegion()}/vcard/homeuser/${getContentListV1?.titleUri(contentInfo)}/${
        contentInfo?.id
      }`,
    );
  };

  return (
    <div className="vertical-card" onClick={handleCardClick}>
      {renderLabel(contentInfo)}
      <FadeInImage
        imageAlt="clarovideo"
        imageSrc={isMobile ?  getContentListV1?.getImage(contentInfo, IMG_SIZE?.MEDIUM)  :  getContentListV1?.getImage(contentInfo, IMG_SIZE?.SMALL)}
        classNames={['vertical-card__image']}
        width={isMobile ? 104 : 256}
        height={isMobile ? 152 : 144}
      />
    </div>
  );
};
